"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mapping = require("../mapping");

var _layoutItem = _interopRequireDefault(require("./layout-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// @ts-ignore
var AemLayout = function AemLayout(_ref) {
  var parentItems = _ref[':items'],
      tools = _ref.tools,
      childNode = _ref.childNode,
      error = _ref.error,
      routerLink = _ref.routerLink,
      pathnameCustom = _ref.pathnameCustom,
      pathname = _ref.pathname;
  var ErrorView = error;

  if (parentItems) {
    var _parentItems$root$It = parentItems.root[':items'].responsivegrid,
        items = _parentItems$root$It[':items'],
        itemsOrder = _parentItems$root$It[':itemsOrder'];
    var hasRoute = true;
    var renderItems = itemsOrder.map(function (key, index) {
      if (!_mapping.AemMapComponent.hasOwnProperty(items[key][':type'])) {
        return;
      }

      if (items[key][':type'] === _mapping.AemMap.RESOURCES_COLUMN_LIST) {
        var _items$key = items[key],
            resourceItems = _items$key[':items'],
            resourceItemsOrder = _items$key[':itemsOrder'],
            rest = _objectWithoutProperties(_items$key, [":items", ":itemsOrder"]);

        var childItems = Object.keys(resourceItems).reduce(function (obj, key) {
          var item = resourceItems[key];

          if (!childNode) {
            obj = _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, _objectSpread({}, item)));
            return obj;
          }

          if (childNode === item.id) {
            obj = _defineProperty({}, key, _objectSpread({}, item));
          }

          return obj;
        }, {});
        var childItemsOrder = resourceItemsOrder.filter(function (item) {
          return Object.keys(childItems).includes(item);
        });

        if (childNode && childItemsOrder.length === 0) {
          hasRoute = false;
        }

        return /*#__PURE__*/_react.default.createElement(_layoutItem.default, _extends({
          key: index
        }, _objectSpread(_objectSpread({
          tools: tools,
          containerCount: index
        }, rest), {}, {
          ':items': childItems,
          ':itemsOrder': childItemsOrder,
          items: resourceItems,
          itemsOrder: resourceItemsOrder,
          routerLink: routerLink,
          pathnameCustom: pathnameCustom,
          pathname: pathname
        })));
      }

      if (items[key][':type'] === _mapping.AemMap.EXPANDER) {
        var _items$key2 = items[key],
            expanderItems = _items$key2[':items'],
            _itemsOrder = _items$key2[':itemsOrder']; // TODO types

        var reducedItems = Object.entries(expanderItems).reduce(function (reduced, _ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          reduced[key] = value.id;
          return reduced;
        }, {});
        return /*#__PURE__*/_react.default.createElement(_layoutItem.default, _extends({}, items[key], {
          items: reducedItems,
          itemsOrder: _itemsOrder,
          key: index,
          tools: tools,
          containerCount: index
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_layoutItem.default, _extends({
        key: index,
        tools: tools,
        containerCount: index
      }, items[key]));
    });
    return childNode && !hasRoute ? /*#__PURE__*/_react.default.createElement(ErrorView, null) : renderItems;
  }

  return null;
};

var _default = AemLayout;
exports.default = _default;